import React, { memo } from 'react'
import PropTypes from 'prop-types'

export const CurrentValue = memo(({ autocomplete, userId, value }) => (
  <>
    {autocomplete ? (
      <a target='_blank' rel='noopener noreferrer' href={`${__ROOT__}/users/${userId}`}>
        {value}
      </a>
    ) : (
      <span>{value}</span>
    )}
  </>
))

CurrentValue.propTypes = {
  autocomplete: PropTypes.bool,
  userId: PropTypes.number,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
CurrentValue.defaultProps = {
  autocomplete: false,
  userId: null,
  value: null,
}
